import React, { useState } from "react";
import IMAGES from "constants/images";
import { Icon } from "@iconify/react";
import { Button, Card, Form, Image, Spinner } from "react-bootstrap";
import RatingStars from "components/RatingStars";
import moment from "moment";
import ShowMoreText from "react-show-more-text";
import { deleteReviewDispute, updateReviewDispute } from "api/ReviewService";
import { toast } from "react-toastify";
import CommonModal from "components/CommonModal";
import TextInput from "components/TextInput";
import CollapsibleText from "components/CollapsibleText";
import { useNavigate } from "react-router-dom";

const DisputeCard = ({ dispute, userId, disputeId, fetchData }) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const navigate = useNavigate();
  const [status, setStatus] = useState(dispute?.status || "active");
  const [selectedReason, setSelectedReason] = useState(dispute?.reason);
  const [description, setDescription] = useState(dispute?.description);
  const [showModal, setShowModal] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const review = dispute?.reviewId;
  const user = dispute?.reviewId?.userId;

  const getStatusBadge = (status) => {
    const statusConfig = {
      active: { label: "Active", className: "badge-active" },
      pending: { label: "Pending", className: "badge-pending" },
      closed: { label: "Closed", className: "badge-closed" },
      resolved: { label: "Resolved", className: "badge-resolved" },
    };
    const { label, className } = statusConfig[status] || {
      label: status,
      className: "bg-secondary",
    };

    return <span className={`mx-2 badge ${className}`}>{label}</span>;
  };

  const handleUpdateDispute = async () => {
    if(description.trim() === ""){
      toast.error("Description is required");
      return;
    }
    setUpdateLoading(true);
    try {
      const payload = {
        reason: selectedReason,
        description: description.trim(),
        status: status,
      };
      const res = await updateReviewDispute(payload, disputeId);
      if (res.success === true && res.code === 200) {
        toast.success(res.message);
        fetchData();
        handleCloseModal();
      } else {
        toast.error(res.message);
      }
      setUpdateLoading(false);
    } catch (err) {
      setUpdateLoading(false);
      toast.error(err.message || "Something went wrong");
    }

  };
  const onEdit = () => {
    setShowModal(true);
  };

  const handleDeleteReviwDispute = async () => {
    try {
      const res = await deleteReviewDispute({ disputeId });
      if (res.success === true && res.code === 200) {
        toast.success(res.message);
        fetchData();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    }
  };
  const onDelete = () => {
    setShowConfirmModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setStatus("");
  };

  return (
    <div className="r_Card mb-4">
      <div className="userFlex userFlex1 mb-4" style={{cursor: 'pointer'}} onClick={() =>{
         navigate(
          review?.userId?._id === userId
            ? `/my-profile`
            : `/public-profile/${review?.userId?._id}`
        );
      }}>
        <Image src={user?.profileUrl ? user?.profileUrl:  IMAGES.User2_Img} alt="" className="imgUser" />
        <div className="userGrow">
          <Card.Title>{user?.displayName ? user?.displayName : `${user?.firstName} ${
            user?.lastName || ""
          }`}</Card.Title>
          <Card.Subtitle className="text-muted mb-0">
              <p
              className="mb-0"
              style={{ fontSize: "0.9em", textTransform: "capitalize" }}
            >
              {[
                review?.userId?.title || "",
                review?.userId?.industry?.title || "",
              ]
                .filter(Boolean)
                .join(", ") +
                (review?.userId?.companySize !== undefined &&
                review?.userId?.companySize !== null &&
                review?.userId?.companySize !== ""
                  ? ` (${review.userId.companySize.title} emp.)`
                  : "")}
            </p>
          </Card.Subtitle>
        </div>
      </div>

      <div className="headerFLex">
        <h4>{review?.title}</h4>
      </div>

      <p className="date_para">
        <RatingStars rating={Number(review?.overallRating)} />
        <span className="ms-1">{moment(review?.createdAt).format("LL")}</span>
      </p>

      <Card className="mb-0 border-0 pb-0">
        <Card.Body className="mb-0">
        <Card.Text className="para">
          <CollapsibleText lines={5}>
          <div dangerouslySetInnerHTML={{ __html: review?.review }} style={{whiteSpace: 'pre-wrap', lineHeight: '1.6', marginBottom: '1rem'}}></div>
          </CollapsibleText>
          </Card.Text>
          {/* <Card.Text>{review?.review}</Card.Text> */}

          <h4 className="mb-3">Dispute</h4>

          <div
            className={`headerFLex ${
              dispute?.status === "active" ? "headerFLexDispute" : ""
            } mb-3`}
          >
            <div>
              <h5 className="mb-0">
                {dispute?.reason}
                {getStatusBadge(dispute?.status)}
              </h5>
              <p className="cardsubtitle mb-0">
                <span>{moment(dispute?.createdAt).format("LL")}</span>
              </p>
            </div>
            {dispute?.status === "active" && (
              <div className="d-flex  header_profile2 justify-content-start" style={{marginLeft:"0px"}}>
                <Button
                  variant="info"
                  className="border-radius-100 ms-auto me-3 hAnswers d-flex align-items-center gap-2"
                  onClick={onEdit}
                >
                  <Icon icon="lucide:edit" fontSize={16} className="" style={{fontSize: '16px'}} />
                <span className="header_profile1 me-2">Edit</span>
                </Button>
                <Button
                  variant="danger"
                  className="border-radius-100 hAnswers d-flex align-items-center gap-2"
                  onClick={onDelete}
                >
                  <Icon icon="mi:delete" fontSize={17} className="" style={{fontSize: '16px'}} />
                  <span className="header_profile1 me-2">Delete</span>
                </Button>
              </div>
            )}
            {dispute?.status === "active" && (
              <div className="d-flex  header_profile3">
                <Button
                  variant="info"
                  className="border-radius-100 me-3 hAnswers d-flex align-items-center gap-2"
                  onClick={onEdit}
                >
                  <Icon icon="lucide:edit" fontSize={16} className="" style={{fontSize: '16px'}} />
                <span className="header_profile1 me-2">Edit</span>
                </Button>
                <Button
                  variant="danger"
                  className="border-radius-100 hAnswers d-flex align-items-center gap-2"
                  onClick={onDelete}
                >
                  <Icon icon="mi:delete" fontSize={17} className="" style={{fontSize: '16px'}} />
                  <span className="header_profile1 me-2">Delete</span>
                </Button>
              </div>
            )}
         
          </div>
     

         <Card.Text className="para">
          <CollapsibleText lines={2}>
          <div dangerouslySetInnerHTML={{ __html: dispute?.description }} style={{whiteSpace: 'pre-wrap', lineHeight: '1.6', marginBottom: '1rem'}}></div>
          {/* {dispute?.description} */}
          </CollapsibleText>
          </Card.Text>
          {dispute?.explanation && (
            <div className="mt-3" style={{ textTransform: "capitalize" }}>
              <p className="mb-3">{`${dispute?.userId?.firstName} ${dispute?.userId?.lastName || ""}'s`} reply</p>
              {/* <ul> */}
                <p style={{whiteSpace: 'pre-wrap', lineHeight: '1.6', marginBottom: '1rem'}}>{dispute?.explanation}</p>
              {/* </ul> */}
            </div>
          )}
        </Card.Body>
      </Card>

      <CommonModal
        title={"Dispute a Review"}
        para={"Describe your issue, and we’ll review it to find a solution."}
        body={
          <div className="mt-4">
            <Form.Group className="mb-3">
              <Form.Label className="d-block text-start">Reason</Form.Label>
              <Form.Select
                placeholder="Select Reason"
                value={selectedReason}
                onChange={(e) => setSelectedReason(e.target.value)}
              >
                <option>Select Reason</option>
                <option>Inappropriate Content</option>
                <option>Spam or Misleading</option>
                <option>Factually Incorrect</option>
                <option>Competitor Review</option>
                <option>Violates Terms of Service</option>
                <option>Other</option>
              </Form.Select>
            </Form.Group>
            <TextInput
              labelText={"Description"}
              type="text"
              textarea="textarea"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={6}
              maxLength={1000}
              placeholder={"Explain dispute in detail..."}
              // errorMessage="Description is required"
            />
            <Form.Group className="mb-3">
              <Form.Label className="d-block text-start">Status</Form.Label>
              <Form.Select
                placeholder="Select status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="active">Active</option>
                <option value="resolved">Resolved</option>
              </Form.Select>
            </Form.Group>

            <Button
              disabled={ updateLoading}
              onClick={handleUpdateDispute}
              variant="info"
              className="w-100 mt-4 border-radius-100"
            >
              {updateLoading ? <Spinner animation="border" size={'sm'}/> : "Submit"}
            </Button>
          </div>
        }
        show={showModal}
        onClose={handleCloseModal}
      />
      <CommonModal
        title="Are you sure?"
        para="Do you really want to delete this review? This action cannot be undone."
        show={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        body={
          <div className="d-flex justify-content-end gap-3 mt-4">
            <Button
              variant="secondary"
              onClick={() => setShowConfirmModal(false)}
              className="border-radius-100"
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={handleDeleteReviwDispute}
              className="border-radius-100"
            >
              Yes
            </Button>
          </div>
        }
      />
    </div>
  );
};

export default DisputeCard;
